<template>
    <q-card class="bg-white"  :flat="page_news">
        <q-card-title v-if="!page_news" class="text-center bg-primary text-white">
            {{ $t(title_news) }}
        </q-card-title>
        <q-card-separator v-if="!page_news" />
        <q-card-main class="text-center relative-position" :style="home ? '' : 'min-height: 50vh'">
            <q-list no-border separator link>
                <q-item v-for="(item, index) in filteredNews" :key="index" class="q-py-lg" @click.native="openNews(item)">
                    <q-item-side>
                        <q-icon name="far fa-newspaper" size="2rem" />
                    </q-item-side>

                    <q-item-main :label="item.title" :sublabel="getDate(item)" />
                </q-item>

                <q-item class="q-py-lg" v-if="news.length === 0 && news_loaded">
                    <q-item-side>
                        <q-icon name="far fa-newspaper" size="2rem" />
                    </q-item-side>

                    <q-item-main :label="$t('no_news_found')" />
                </q-item>
            </q-list>

            <q-inner-loading :visible="!news_loaded">
                <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
            </q-inner-loading>
        </q-card-main>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "news"] },

    props: {
            news:Array,
            news_loaded:Boolean,
            home:Boolean,
            page_news:{
               type: Boolean,
               default: false
            }
    },

    data() {
        return {

        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        filteredNews() {
            let news = Object.assign([], this.news)

            if (this.home) {
                return news.slice(0, 5)
            }
            else return news
        },

        title_news(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_news == "" ? 'news' : obj.title_news
				}
			}
		},
    },

    methods: {
        openNews(item) {
            this.$emit('openNews', item)
        },

        getDate(item) {
            if (item.publish_date) {
                return moment(item.publish_date).format('DD/MM/YYYY')
            }
            else return moment(item.created_date).format('DD/MM/YYYY')
        }
    },
}
</script>

<style>

</style>
